import { FundingKey } from '@bytel/leviator';

export function getFundingLabels(fundingKey: FundingKey): string {
    switch (fundingKey) {
        case FundingKey.COMPTANT:
            return 'Comptant';
        case FundingKey.EDP:
            return 'Facilité de paiement sans frais';
        default: {
            return 'Financement smartphone';
        }
    }
}
